/**
 * カラースウォッチクリックで商品カード画像を切り替える
 */
(function() {
  'use strict';

  // CSSを動的に追加（hover競合を回避）
  function injectStyles() {
    if (document.getElementById('color-swatch-switcher-styles')) return;
    
    const style = document.createElement('style');
    style.id = 'color-swatch-switcher-styles';
    style.textContent = `
      /* swatch-activeクラスがある場合、hoverによる画像切り替えを無効化 */
      .product-card.swatch-active .product-card__image--main {
        opacity: 1 !important;
        transition: opacity 0.15s ease !important;
      }
      .product-card.swatch-active .product-card__image--second {
        opacity: 0 !important;
      }
    `;
    document.head.appendChild(style);
  }

  function initColorSwatchSwitcher() {
    injectStyles();
    
    const swatches = document.querySelectorAll('.color-swatch-simple__dot[data-variant-image]');
    
    swatches.forEach(swatch => {
      // data-variant-imageが空でないものだけ処理
      if (!swatch.dataset.variantImage) return;
      
      // クリック可能なスタイルを追加（既存スタイルを上書きしない）
      swatch.style.cursor = 'pointer';
      
      swatch.addEventListener('click', handleSwatchClick);
    });

    // mouseleaveでswatch-activeクラスを削除
    document.querySelectorAll('.product-card').forEach(card => {
      card.addEventListener('mouseleave', () => {
        card.classList.remove('swatch-active');
      });
    });
  }

  function handleSwatchClick(e) {
    const swatch = e.currentTarget;
    const newImageUrl = swatch.dataset.variantImage;
    
    if (!newImageUrl) return;
    
    // 親の商品カードを取得
    const productCard = swatch.closest('.product-card');
    if (!productCard) return;
    
    // メイン画像を取得
    const mainImageWrapper = productCard.querySelector('.product-card__image--main');
    if (!mainImageWrapper) return;
    
    const mainImage = mainImageWrapper.querySelector('img');
    if (!mainImage) return;

    // 2枚目画像を取得（非表示にするため）
    const secondImageWrapper = productCard.querySelector('.product-card__image--second');
    const secondImage = secondImageWrapper ? secondImageWrapper.querySelector('img') : null;

    // swatch-activeクラスを追加してhover挙動を無効化
    productCard.classList.add('swatch-active');
    
    // フェードアウト
    mainImage.style.transition = 'opacity 0.15s ease';
    mainImage.style.opacity = '0';
    
    // 画像ロード完了後にフェードイン
    setTimeout(() => {
      // srcsetをクリアしてsrcのみで表示
      mainImage.srcset = '';
      mainImage.src = newImageUrl;
      
      // 画像ロード完了を待つ
      const showImage = () => {
        mainImage.style.opacity = '1';
      };

      if (mainImage.complete) {
        showImage();
      } else {
        mainImage.onload = showImage;
        mainImage.onerror = showImage;
      }
    }, 150);
  }

  // DOM読み込み完了後に初期化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initColorSwatchSwitcher);
  } else {
    initColorSwatchSwitcher();
  }
})();
